import { GeoContainer } from '../../containers/filters/GeoContainer';
import { EFilterType, IDefaultFilter } from '../../types/filters';

export const geo: IDefaultFilter = {
  component: GeoContainer,
  type: EFilterType.Default,
};
